import { useCallback, useState } from 'react';

export const useScrollSpyWaypoint = (defaultTab: string, scrollOffset = 120) => {
  const [currentTab, setCurrentTab] = useState(defaultTab);
  const onTabChange = useCallback(
    (e, i) => {
      if (i !== currentTab) scrollToElement(document.getElementById(i), scrollOffset);
      // const element = ;
      // const parent: HTMLElement = getScrollParent(element);
      // if (parent) {
      // scrollToRelative(element, 120, parent);
      // setCurrentTab(i);
      // disableOnChange.current = true;
      // setTimeout(() => (disableOnChange.current = false), 1000);
      // }
    },
    [currentTab, scrollOffset]
  );

  const onWayPointEnter = useCallback(
    i => () => {
      // !disableOnChange.current &&
      setCurrentTab(i);
    },
    [setCurrentTab]
  );
  return { currentTab, onTabChange, onWayPointEnter };
};
function getScrollParent(node) {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}

function scrollToRelative(element: HTMLElement, headerOffset = 45, target: HTMLElement) {
  var elementPosition =
    element.getBoundingClientRect().top - target.getBoundingClientRect().top + target.scrollTop;
  var offsetPosition = elementPosition - headerOffset;

  target.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
}

export function scrollToElement(element: HTMLElement, headerOffset = 45) {
  const parent = getScrollParent(element);
  parent && scrollToRelative(element, headerOffset, parent);
}
